import React from 'react';
import { useFormik } from 'formik';
import { CustomInput, FormGroup, Input, Label } from 'reactstrap';
import { Button } from '../../../UI/Common';
import { useTranslation } from 'react-i18next';

const Widget2Properties = ({ properties, onChange, ...props }) => {
  const { t } = useTranslation('app');
  const { values, setFieldValue, handleChange, ...formik } = useFormik({
    initialValues: properties,
    onSubmit: () => onChange(values),
    enableReinitialize: true,
  });
  React.useEffect(() => {
    formik.handleSubmit();
  }, [values]);
  function changeNumberValue(e, key) {
    let val = parseInt(e.target.value);
    if (Number.isNaN(val)) {
      setFieldValue(key, 1);
    } else {
      setFieldValue(key, val);
    }
  }
  return (
    <div>
      <div className="d-flex align-items-center">
        <span className="w-100 text-center">{t('Properties')}</span>
        <Button
          classes="d-flex align-items-center"
          style={{ padding: '0px 2px', height: 30 }}
          onClick={() => props.setIsActive('')}
        >
          <i className="md-icon mr-0">close</i>
        </Button>
      </div>
      <FormGroup>
        <Label>Title</Label>
        <Input
          value={values.title}
          onChange={(e) => setFieldValue('title', e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label>Description</Label>
        <Input
          value={values.description}
          onChange={(e) => setFieldValue('description', e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label>Max Width</Label>
        <Input
          value={values.width}
          onChange={({ target }) => setFieldValue('width', target.value)}
        />
      </FormGroup>
      <strong>Spacing around</strong>
      <div className="d-flex">
        <FormGroup>
          <Label>Top</Label>
          <Input
            type="number"
            value={values.extraProperties.spacingTop}
            onChange={({ target }) =>
              setFieldValue('extraProperties.spacingTop', target.value)
            }
          />
        </FormGroup>
        <FormGroup>
          <Label>Right</Label>
          <Input
            type="number"
            value={values.extraProperties.spacingRight}
            onChange={({ target }) =>
              setFieldValue('extraProperties.spacingRight', target.value)
            }
          />
        </FormGroup>
        <FormGroup>
          <Label>Bottom</Label>
          <Input
            type="number"
            value={values.extraProperties.spacingBottom}
            onChange={({ target }) =>
              setFieldValue('extraProperties.spacingBottom', target.value)
            }
          />
        </FormGroup>
        <FormGroup>
          <Label>Left</Label>
          <Input
            type="number"
            value={values.extraProperties.spacingLeft}
            onChange={({ target }) =>
              setFieldValue('extraProperties.spacingLeft', target.value)
            }
          />
        </FormGroup>
      </div>
      <FormGroup>
        <CustomInput
          id={`widget-${values.id}`}
          type="checkbox"
          label="Terminate Row"
          checked={values.terminateRow}
          onChange={(e) => {
            setFieldValue('terminateRow', e.target.checked);
          }}
        />
      </FormGroup>
    </div>
  );
};

export default Widget2Properties;
